import { useApi, createApiHook } from "../utils/apiUtils";

const useUpdateInstrument = () => {
  const { apiPatch } = useApi();
  const useApiState = createApiHook(null);
  const { error, startLoading, setResponse } = useApiState();

  const updateInstrument = async ({ id, name } = {}) => {
    if (!id) return false;

    const body = {};
    if (typeof name !== "undefined") body.name = name;

    if (Object.keys(body).length === 0) {
      setResponse({ message: "Sin cambios, no se envío información" });
      return true;
    }

    startLoading();
    const response = await apiPatch(`/instruments/${id}`, "Error al actualizar el instrumento", body);
    setResponse(response);
    return !response?.error;
  };

  return { updateInstrument, error };
};

export default useUpdateInstrument;
